import {Injectable} from '@angular/core';

@Injectable()
export class JsonCodecService {

    public encode(data: any): string {
        return JSON.stringify(data);
    }

    public decode(encoded: string): any {
        return JSON.parse(encoded);
    }
}
